import { TieredMenu } from "primereact/tieredmenu";
import { classNames } from "primereact/utils";
import { ReactElement } from "react";

export interface MultiSortMenuEntry {
    field: string;
    label: string | ReactElement | null;
}

export type MultiSortMenuEntrys = Array<MultiSortMenuEntry>;

interface MultiSortMenuProps {
    items: MultiSortMenuEntrys;
    menuRef: React.RefObject<any>;
    onSortMenuClick: (field: string) => void;
    sortAsc: boolean;
    sortType: string;
}

const MultipleSortMenu = (props: MultiSortMenuProps) => {
    const {
        items = [],
        onSortMenuClick = () => {},
        sortAsc = false,
        sortType = "",
    } = props;

    return (
        <div>
            <TieredMenu
                // label-prop from menuEntry is compatible but its throwing an error because of prime-react-typing
                // @ts-ignore
                model={items.map((menuEntry) => ({
                    label: menuEntry.label || "",
                    icon:
                        classNames("pi", "text-default", {
                            "pi-sort-alt": sortType !== menuEntry.field,
                            "pi-sort-amount-up":
                                sortAsc && sortType === menuEntry.field,
                            "pi-sort-amount-down":
                                !sortAsc && sortType === menuEntry.field,
                        }) || "",
                    command: () => onSortMenuClick(menuEntry.field),
                    className: classNames({
                        "bg-primary-default/10": sortType === menuEntry.field,
                    }),
                }))}
                popup
                ref={props.menuRef}
            />
        </div>
    );
};

export default MultipleSortMenu;
